/**
 * OverdueInvoicesBanner Component - T133
 *
 * Alert banner showing count of overdue invoices
 */
import { Link } from '@tanstack/react-router';
import { useInvoiceList } from '../../hooks/useInvoices';
import { formatCurrency } from '@armard/shared';

export function OverdueInvoicesBanner() {
  const { data } = useInvoiceList({
    status: 'overdue',
    limit: 100,
  });

  if (!data || data.total === 0) {
    return null;
  }

  const totalOverdue = data.invoices.reduce(
    (sum, inv) => sum + parseFloat(inv.grossTotal),
    0
  );

  return (
    <div className="bg-red-500/10 backdrop-blur-sm border border-red-500/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-500/20 rounded-full">
            <svg
              className="w-5 h-5 text-red-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <div>
            <p className="text-red-400 font-medium">
              {data.total} {data.total === 1 ? 'Rechnung überfällig' : 'Rechnungen überfällig'}
            </p>
            <p className="text-sm text-red-400/70">
              Gesamtbetrag: {formatCurrency(totalOverdue)}
            </p>
          </div>
        </div>
        <Link
          to="/invoices"
          search={{ status: 'overdue' }}
          className="text-sm text-red-400 hover:text-red-300 transition-colors"
        >
          Anzeigen →
        </Link>
      </div>
    </div>
  );
}
